import { useContext } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import { AIChatBotContext } from '../../context'
import useStyles from './index.styles'

type Props = BoxProps

export const TypingIndicator = ({
  children,
  styles,
  classNames,
  className,
  ...boxProps
}: Props) => {
  const { formatMessage: f } = useIntl()
  const { name } = useContext(AIChatBotContext)
  const { classes, cx } = useStyles(undefined, {
    name: 'AIChatBotWidget__TypingIndicator',
    styles,
    classNames,
  })
  return (
    <Box className={cx(classes.root, className)} {...boxProps}>
      <div className="cs-typing-indicator">
        <div className="indicator">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
        <Text size="n1" className="text">
          {f({ id: 'chatbot.isTypingState' }, { name })}
        </Text>
      </div>
    </Box>
  )
}
